import { render } from "./SidebarNewCollectionButton.vue?vue&type=template&id=16873529"
import script from "./SidebarNewCollectionButton.vue?vue&type=script&lang=js"
export * from "./SidebarNewCollectionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__